import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

const Gallery = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  // ✅ Lightbox slides (same images)
  const slides = [
    { src: "/r1.jpeg" },
    { src: "/r2.jpeg" },
    { src: "/r3.jpeg" },
    { src: "/r4.jpeg" },
    { src: "/r5.jpeg" },
    { src: "/r6.jpeg" },
    { src: "/r7.jpeg" },
    { src: "/r8.jpeg" },
  ];

  return (
    <>
      <div className="dr-header">
        <div className="header-contant">
          <h1>Gallery</h1>
          <p>Doctor {" > "} Gallery</p>
        </div>
      </div>

      <div className="gallery">
        <div className="gallery-row">

          <div className="gallery-col" onClick={() => { setIndex(0); setOpen(true); }}>
            <img src="/r1.jpeg" alt="" />
          </div>

          <div className="gallery-col" onClick={() => { setIndex(1); setOpen(true); }}>
            <img src="/r2.jpeg" alt="" />
          </div>

          <div className="gallery-col" onClick={() => { setIndex(2); setOpen(true); }}>
            <img src="/r3.jpeg" alt="" />
          </div>

          <div className="gallery-col" onClick={() => { setIndex(3); setOpen(true); }}>
            <img src="/r4.jpeg" alt="" />
          </div>

          <div className="gallery-col" onClick={() => { setIndex(4); setOpen(true); }}>
            <img src="/r5.jpeg" alt="" />
          </div>

          <div className="gallery-col" onClick={() => { setIndex(5); setOpen(true); }}>
            <img src="/r6.jpeg" alt="" />
          </div>

          <div className="gallery-col" onClick={() => { setIndex(6); setOpen(true); }}>
            <img src="/r7.jpeg" alt="" />
          </div>

          <div className="gallery-col" onClick={() => { setIndex(7); setOpen(true); }}>
            <img src="/r8.jpeg" alt="I" />
          </div>

        </div>
      </div>

      {/* ✅ Lightbox */}
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={slides}
        index={index}
      />
    </>
  );
};

export default Gallery;